"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var style_1 = require("../../../style");
var data_display_1 = require("../../data-display");
var layout_1 = require("../../layout");
var Text_1 = __importDefault(require("../../Text"));
var context_1 = require("./context");
var SIZE_MAP = {
    small: 8,
    default: 22,
    large: 22,
};
var BADGE_PROPS_MAP = {
    primary: {
        default: {
            color: 'primary',
            mode: 'light',
        },
        destructive: {
            color: 'error',
            mode: 'light',
        },
    },
    dark: {
        default: {
            color: 'primary',
            mode: 'light',
        },
        destructive: {
            color: 'error',
            mode: 'light',
        },
    },
    secondary: {
        default: {
            color: 'gray',
            mode: 'dark',
        },
        destructive: {
            color: 'error',
            mode: 'dark',
        },
    },
    tertiary: {
        default: {
            color: 'gray',
            mode: 'dark',
        },
        destructive: {
            color: 'error',
            mode: 'dark',
        },
    },
    'link-primary': {
        default: {
            color: 'primary',
            mode: 'dark',
        },
        destructive: {
            color: 'error',
            mode: 'dark',
        },
    },
    'link-secondary': {
        default: {
            color: 'gray',
            mode: 'dark',
        },
        destructive: {
            color: 'error',
            mode: 'dark',
        },
    },
};
var DOT_PROPS_MAP = {
    primary: {
        default: {
            color: 'Primary',
            theme: 'light',
        },
        destructive: {
            color: 'Error',
            theme: 'light',
        },
    },
    dark: {
        default: {
            color: 'Primary',
        },
        destructive: {
            color: 'Error',
        },
    },
    secondary: {
        default: {
            color: 'Gray',
        },
        destructive: {
            color: 'Error',
        },
    },
    tertiary: {
        default: {
            color: 'Gray',
        },
        destructive: {
            color: 'Error',
        },
    },
    'link-primary': {
        default: {
            color: 'Primary',
        },
        destructive: {
            color: 'Error',
        },
    },
    'link-secondary': {
        default: {
            color: 'Gray',
        },
        destructive: {
            color: 'Error',
        },
    },
};
var ButtonBadge = function (_a) {
    var children = _a.children;
    var _b = context_1.useButtonContext(), size = _b.size, variant = _b.variant, destructive = _b.destructive, disabled = _b.disabled;
    var badgeProps = react_2.useMemo(function () { return BADGE_PROPS_MAP[variant][destructive ? 'destructive' : 'default']; }, [variant, destructive]);
    var dotProps = react_2.useMemo(function () { return DOT_PROPS_MAP[variant][destructive ? 'destructive' : 'default']; }, [variant, destructive]);
    return size === 'small' ? (react_1.jsx(data_display_1.Dot, __assign({}, dotProps, { size: "md", disabled: disabled }))) : (react_1.jsx(data_display_1.Badge, __assign({}, badgeProps, { disabled: disabled }), children));
    return (react_1.jsx(layout_1.Flex, { alignItems: "center", justifyContent: "center", css: {
            minWidth: SIZE_MAP[size],
            minHeight: SIZE_MAP[size],
            borderRadius: SIZE_MAP[size] / 2,
            backgroundColor: size === 'small' && variant !== 'primary'
                ? style_1.DesignSystemThemeColor.Success.DEFAULT
                : 'currentcolor',
            margin: size === 'small' ? 2 : 0,
            padding: size === 'small' ? undefined : '2px 8px',
        } },
        react_1.jsx(Text_1.default.Body, { size: "sm", weight: "semibold", css: {
                color: variant === 'primary' ? style_1.DesignSystemThemeColor.Primary.DEFAULT : 'white',
            } }, size !== 'small' ? children : null)));
};
exports.default = ButtonBadge;
